import HeroPolicy from "@/components/common/HeroPolicy";
import Container from "@/components/layout/Container";

const EmailRefusal = () => {
  return (
    <Container>
      <HeroPolicy />

      <main id="main-content">
        <div>
          {/* Content */}
          <div className="text-center mt-14">
            <div className="w-20 h-20 mx-auto my-5 rounded-full bg-[#f0f3ff] flex items-center justify-center">
              <span className="material-icons-round text-[3.6rem] text-navy">email</span>
            </div>
            <h2 className="text-[2.8rem] font-bold text-black mb-6">이메일 무단수집 거부</h2>
            <p className="text-[1.6rem] text-gray-6 leading-[1.8] mb-4">
              정보통신망법에 따라 <span className="font-semibold text-navy">무단 수집</span>을
              금지합니다.
            </p>

            <div className=" mx-auto mb-12">
              <p className="text-[1.6rem] text-gray-6 leading-[1.9]">
                본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를
                이용하여 무단으로 수집되는 것을 거부하며,
                <br />
                이를 위반시{" "}
                <span className="font-semibold text-navy">정보통신망법에 의해 형사처벌</span>됨을
                유념하시기 바랍니다.
              </p>
            </div>

            <div className="bg-[#f8f9ff] rounded-2xl p-8 text-left max-w-[800px] mx-auto">
              <h3 className="text-[1.8rem] font-bold text-navy mb-6">관련 법령</h3>
              <p className="text-[1.5rem] font-semibold text-gray-7 mb-2">
                정보통신망 이용촉진 및 정보보호 등에 관한 법률
              </p>
              <p className="text-[1.4rem] text-gray-5 mb-6">
                제50조의2 (전자우편주소의 무단 수집행위 등 금지)
              </p>
              <ol className="list-decimal pl-6 space-y-4 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>
                  누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로
                  전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를
                  수집하여서는 아니된다.
                </li>
                <li>
                  누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니된다.
                </li>
                <li>
                  누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된
                  전자우편주소임을 알고 이를 정보전송에 이용하여서는 아니된다.
                </li>
              </ol>
            </div>

            <div className="mt-12 mb-40 border-gray-2">
              <p className="text-[1.4rem] text-gray-5">게시일 : 2014-03-01</p>
            </div>
          </div>
        </div>
      </main>
    </Container>
  );
};

export default EmailRefusal;
